import React, { useEffect, useState, useRef } from "react";
import "./ChatStyles.css";
import io from "socket.io-client";
import axios from "axios";
import ImageContainer from "../components/ImageContainer";
import { IoSendSharp } from "react-icons/io5";
import {
  BsImageFill,
  BsFillCameraVideoFill,
  BsFillPlayCircleFill,
} from "react-icons/bs";
import {
  AiOutlineCloseCircle,
  AiOutlineStop,
  AiFillDelete,
} from "react-icons/ai";
import { MdAttachment, MdDoneAll } from "react-icons/md";
import { RiUserSearchLine } from "react-icons/ri";
import TenPointLogo from "../assets/10pointlogo.png";
import CustomModal from "../components/CustomModal";
import { uploadingImage } from "../utilities/customUpload";
import Offcanvas from "react-bootstrap/Offcanvas";
import { BiArrowBack, BiCheck } from "react-icons/bi";
import { IoMdRefresh } from "react-icons/io";
import Spinner from "react-bootstrap/Spinner";
import { LuSendHorizonal } from "react-icons/lu";
import { IoIosImages } from "react-icons/io";
import Skeleton from "@mui/material/Skeleton";
import { MdContentCopy } from "react-icons/md";
import SnackBar from "../components/SnackBar";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";


const timestampToHumanDate = (timestamp, type) => {
  // Convert timestamp to milliseconds
  const milliseconds = timestamp * 1000;

  // Create a new Date object
  const date = new Date(milliseconds);

  // Array of month names
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Get day, month, and year
  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();

  // Format the date

  return (
    day.toString().padStart(2, "0") + " " + monthNames[monthIndex] + " " + year
  );
};
const finalUrl =
  process.env.NODE_ENV == "developmentt"
    ? "http://127.0.0.1:3001"
    : "https://app.10point.ai";

const socket = io.connect(finalUrl);

const Chat = () => {
  // useEffect(()=>console.log(socket))
  // setting current message
  const [curr_message, setCurrMessage] = useState("");

  // month array
  const month = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  // snackbar state
  const [snackbarStatus, setSnakckbarStatus] = useState(false);

  // setting conversation happened on a particular day
  let conversation = [];
    const navigate = useNavigate()

  const [search, setSearch] = useState("");
  // const history = useNavigate()

  const containerRef = useRef(null);
  const scrollRef = useRef();

  // loading the messages on click
  const [loadmessages, setLoadMessage] = useState([]);

  // setting the room with current user
  const [room, setRoom] = useState("");
  
  const [chatName, setChatName] = useState("");

  const [profileImage, setprofileImage] = useState("");
  // setting up chat
  const [chat, setChat] = useState(false);

  // setting all the active users
  const [active, setActive] = useState([]);

  const [searchArray, setSearchArray] = useState([]);

  const [show, setShow] = useState(false);
  const [modal, setModal] = useState(false);

  const [imageUrl, setImageUrl] = useState("");

  const [videoUrl, setVideoUrl] = useState("");

  const [mediaModalShow, setMediaModalShow] = useState(false);
  // const [loader , setLoader] = useState(false) ;

  const [canvaShow, setCanvaShow] = useState(false);
  const [userProfile, setUserProfile] = useState({
    user: {},
    orders: [],
    subscriptions: [],
  });

  const [file, setFile] = useState("");

  const inputRef = useRef(null);

  const handleClose = () => {
    setShow(false);
    setMediaModalShow(false);
    setTimeout(() => {
      if (imageUrl.length > 0) setImageUrl("");
      if (videoUrl.length > 0) setVideoUrl("");
    }, 300);
  };

  const handleShowImage = (url) => {
    setImageUrl(url);
    setTimeout(() => {
      setShow(true);
    }, 300);
  };

  const handleShowVideo = (url) => {
    setVideoUrl(url);
    setTimeout(() => {
      setShow(true);
    }, 300);
  };

  // scroll to Bottom
  const scrollToDown = () => {
    if (scrollRef && scrollRef.current) {
      setTimeout(() => {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }, 0);
    }
  };

  // getting all user which is having a query
  const allQueryUser = async () => {
    const { data } = await axios.get(`${finalUrl}/api/allquery`);
    setActive(data.result);

    // console.log("this is in all query user : ", data.result);
  };

  useEffect(() => {
    allQueryUser();

    if (inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  // scroll To Bottom will automatically take to last message
  const scrollToBottom = () => {
    containerRef.current?.scrollIntoView({ behaviour: "smooth" });
  };

  const deleteMsg = (chat_id) => {
    const deleteInfo = {
      chat_id: chat_id,
      user_id: room,
    };

    socket.emit("delete_message", deleteInfo);

    setLoadMessage(
      loadmessages.map((lmsg) => {
        if (lmsg.chat_id == chat_id) lmsg.message_status = "inactive";

        return lmsg;
      })
    );

    allQueryUser();
  };

  useEffect(() => {
    scrollToBottom();
  }, [curr_message]);

  useEffect(() => {
    socket.on("sending_to_admin", (data) => {
      console.log("in admin data : ", data);
      console.log("current room : ", room);
      allQueryUser();
      if (data.length > 1) {
        if (data[1]?.user_user_id != room) return;
        setLoadMessage((loadmessages) => [...loadmessages, data[1], data[0]]);
      } else {
        if (data[0]?.user_user_id != room) return;
        setLoadMessage((loadmessages) => [...loadmessages, data[0]]);
      }
      setTimeout(() => {
        scrollToDown();
      }, 100);
    });

    socket.on("sending_to_clients", (data) => {
      console.log("in client data : ", data.length);
      allQueryUser();
      console.log("incoming message room ", data);
      console.log("in client room : ", room);
      console.log("current loadmessage user : ", loadmessages[0]?.user_user_id);
     if (data.length > 1) {
//        if (data[1]?.sent_by != 'admin') return;

        setLoadMessage((loadmessages) => [...loadmessages, data[1], data[0]]);
      } else {
        // if (data[0]?.sent_by != 'admin') return;

        setLoadMessage((loadmessages) => [...loadmessages, data[0]]);
      }
      setTimeout(() => {
        scrollToDown();
      }, 100);
    });

    return () => {
      socket.off("sending_to_admin");
      socket.off("sending_to_clients");
    };
  }, [room]);

  useEffect(() => {
    const keyDownHandler = (event) => {
      if (event.key == "Enter" && !event.shiftKey && window.innerWidth > 500) {
        event.preventDefault();
        sendMessage("", "text");
      }
    };

    document.addEventListener("keydown", keyDownHandler);

    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [curr_message]);

  // turning url into links in message and adding line breaks
  const Linkify = (message) => {
    if (message.trim().length == 0) return;
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    message = message.replace(/\n/g, "<br/>");

    const locationUrl = finalUrl;

    message = message.replaceAll("[%host_url%]", locationUrl);

    return message.replace(urlRegex, function (url) {
      url = url.replaceAll("<br/>", "");
      return `<a href=${url} target="_blank" style="color :#8ae38f" }}>${url}</a>`;
    });
  };

  console.log(window.location.hash)

  useEffect(() => {
    if (!window.location.hash) {
      setCanvaShow(false)

    }
  }, [window.location.hash]);

  // getting all the chats
  const chatWindow = async (id, name, profileImage) => {
    setCurrMessage("");
    // window.lo  cation.hash = 'chat'
    navigate('/#/')
    
    if (room != id) {
      if (room != "") socket.emit("leave", room);
      console.log(id, "roooom");
      socket.emit("joinRoom", id);
      setRoom(id);
      setChatName(name);
      setprofileImage(profileImage);
      setChat(true);
      if (window.innerWidth <= 440) setCanvaShow(true);

      const { data } = await axios.get(
        `${finalUrl}/api/userchat?user_id=${id}&requested_by=admin`
      );
      setLoadMessage(data.result);
      scrollToDown();
    } else {
      console.log(id, "roooom already");
      if (window.innerWidth <= 440) setCanvaShow(true);
     
      const { data } = await axios.get(
        `${finalUrl}/api/userchat?user_id=${id}&requested_by=admin`
      );
      setLoadMessage(data.result);
      scrollToDown();
    }

    if (searchArray.length > 0) {
      setSearchArray([]);
      setSearch("");
    }
    setTimeout(() => {
      scrollToBottom();
    }, 1);
  };
  // sending the message
  const sendMessage = async (url, media_type) => {
    if ((curr_message.trim().length || url.length > 0) && active.length > 0) {
      const created_at = Math.round(new Date().getTime() / 1000);
      const messageData = {
        sent_by: "admin",
        Id: room,
        message: curr_message,
        url: url,
        media_type: media_type,
        created_at: created_at,
        updatemssg: `${curr_message.replaceAll("'", `\'\'`)}`,
      };

      //  setLoadMessage([...loadmessages , {message : curr_message , sent_by : 'admin' , media_type : media_type ,created_at : created_at , url : url}]) ;
      setCurrMessage("");

      socket.emit("joinRoom", room);
      socket.emit("send_message", messageData);
      if (mediaModalShow) handleClose();
      scrollToDown();
    }
  };

  // function for calculating time of a particular message
  const handleTime = (created_at) => {
    const d = new Date(parseInt(created_at) * 1000);
    let am_pm,
      hrs = d.getHours(),
      min = d.getMinutes();
    if (hrs >= 12) {
      am_pm = " pm ";
    } else {
      am_pm = " am ";
    }

    if (hrs < 10) hrs = "0" + hrs;

    if (min < 10) min = "0" + min;

    return hrs + ":" + min + am_pm;
  };

  // search function to search by name a particular user
  const searchUser = (event) => {
    setSearch(event.target.value);

    if (event.target.value.length == 0) {
      setSearchArray([]);
      return;
    }

    setSearchArray(
      active.filter((search) => {
        return (
          search.full_name != null &&
          search.full_name
            .toLowerCase()
            .includes(event.target.value.toLowerCase())
        );
      })
    );
  };

  // to refresh the page
  const refreshPage = () => {
    window.location.reload(false);
  };

  // clearing the search bar
  const clearSearch = () => {
    setSearch("");
    setSearchArray([]);
  };

  const handleFile = (event) => {
    if (
      event.target.files &&
      event.target.files.length > 0 &&
      event.target.files[0].type.includes("video")
    ) {
      // setLoader(true);
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.addEventListener("load", () => {
        uploadImage(reader.result, "video");
      });
    }

    if (
      event.target.files &&
      event.target.files.length > 0 &&
      event.target.files[0].type.includes("image")
    ) {
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.addEventListener("load", () => {
        uploadImage(reader.result, "image");
      });
    }
  };

  const uploadImage = (file, type) => {
    if (type == "video") {
      uploadingImage(dataURItoBlob(file), `chat`, `${room}`)
        .then((res) => {
          setVideoUrl(res.filename);
          setTimeout(() => {
            setMediaModalShow(true);
            scrollToDown();
          }, 1000);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      // setLoader(true);
      uploadingImage(dataURItoBlob(file), `chat`, `${room}`)
        .then((res) => {
          setImageUrl(res.filename);
          setTimeout(() => {
            setMediaModalShow(true);
            scrollToDown();
          }, 1000);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const dataURItoBlob = (dataURI) => {
    var byteString = atob(dataURI.split(",")[1]);

    // separate out the mime component
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  };

  const handleDate = (created_at) => {
    const d = new Date(created_at * 1000);
    const completeDate =
      d.getDate() + " " + month[d.getMonth()] + " " + d.getFullYear();

    if (conversation.includes(completeDate)) {
      return null;
    } else {
      conversation.push(completeDate);
      return <p className="chatStartDate">{completeDate}</p>;
    }
  };

  const handleCanva = () => {
    setCanvaShow(false);
    // window.history.go(-1);

    socket.emit("leave", room);
    setTimeout(() => {
      console.log("leaving socket");
      setLoadMessage([]);
    }, 100);
  };
  const handleCanvaWithoutBack = () => {
    setCanvaShow(false);
    // window.history.go(-1);

    socket.emit("leave", room);
    setTimeout(() => {
      setLoadMessage([]);
    }, 1000);
  };

  const lastMsgDate = (created_at) => {
    const d = new Date(created_at * 1000);
    const completeDate =
      d.getDate() + " " + month[d.getMonth()] + ", " + (d.getFullYear() % 100);

    return completeDate;
  };

  const numOfSkeleton = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  const copyText = (msg) => {
    setSnakckbarStatus(true);

    const locationUrl = finalUrl;
    msg = msg.replaceAll("[%host_url%]", locationUrl);

    navigator.clipboard.writeText(msg);
  };

  console.log("total user messages : ", loadmessages);

  const openUserProfile = async () => {
    const { data } = await axios.get(
      `${finalUrl}/api/getUserProfileForChatAdmin?user_id=${room}`
    );
    setUserProfile(data.result);
    console.log(data.result);
    setModal(true);
  };

  return (
    <div className="chat-container">
      <div className="chatLeftSection">
        <div className="tenPointQuerySupportContainer">
          <div className="tenPointLogoNameCont">
            <div className="tenPointLogoNameInfo">
              <img
                className="tenPointLogo"
                src={TenPointLogo}
                style={{ width: "50px", height: "50px", borderRadius: "50%" }}
              />
              <p className="TenPointName">Query Support</p>
            </div>
            <div className="tenPointOtherOptionCont">
              <IoMdRefresh
                className="refreshIcon"
                onClick={() => refreshPage()}
              />
            </div>
          </div>
          <div className="searchInputContainer">
            <div className="searchBtnCont">
              <RiUserSearchLine style={{ color: "gray", fontSize: "12px" }} />
            </div>
            <div className="searchInput">
              <input
                className="search"
                name="search"
                type="text"
                value={search}
                placeholder="Search"
                onChange={(event) => searchUser(event)}
              />
            </div>
            <div
              className="closeBtnContainer"
              onClick={() => clearSearch()}
              style={{ visibility: search.length > 0 ? "visible" : "hidden" }}
            >
              <AiOutlineCloseCircle
                style={{ fontSize: "12px", color: "gray" }}
              />
            </div>
          </div>
          <div className="currentTabStatus">
            <div className="chatTabContainer">
              <p className="tabName">Chats</p>
            </div>
            <div className="updateTabContainer">
              <p className="tabName">Updates</p>
            </div>
          </div>
        </div>
        <div className="userQueryListContainer">
          {searchArray.length > 0 ? (
            searchArray.map((user, index) => {
              return (
                <>
                  <div
                    className="userQueryList"
                    key={index}
                    onClick={() => {
                      user.message_status = "seen";
                      chatWindow(
                        user.user_user_id,
                        user.full_name,
                        user.profile_image
                      );
                    }}
                  >
                    <div className="userImageAndNameCont">
                      <img
                        src={user.profile_image}
                        className="userProfileImageInChatInfo"
                      />
                    </div>
                    <div className="userLastMessageContainer">
                      <p className="userNameQuery">{user.full_name}</p>
                      {/* { 
                    user.unseen_messages != 0 ?
                   <p className='unseenMessageCount'>{user.unseen_messages}</p>  : null
                  } */}
                      {user.message_status != "inactive" ? (
                        user.media_type == "image" ? (
                          <div className="userLastMessageInfo">
                            <div className="userMessage">
                              <p className="lastMessage">
                                <BsImageFill />
                                &nbsp;Image
                              </p>
                            </div>
                            <div className="userTimeAndUnseenMessageCont">
                              <span className="lastMessagedeliverDate">
                                {lastMsgDate(user.created_at) +
                                  " | " +
                                  handleTime(user.created_at)}
                              </span>
                              {/* <span className='unseenMessageCount'>{user.delivered_count > 0 ? user.delivered_count : null}</span> */}
                            </div>
                          </div>
                        ) : user.media_type == "video" ? (
                          <div className="userLastMessageInfo">
                            <div className="userMessage">
                              <p className="lastMessage">
                                <BsFillCameraVideoFill />
                                &nbsp;Video
                              </p>
                            </div>
                            <div className="userTimeAndUnseenMessageCont">
                              <span className="lastMessagedeliverDate">
                                {lastMsgDate(user.created_at) +
                                  " | " +
                                  handleTime(user.created_at)}
                              </span>
                              {/* <span className='unseenMessageCount'>{user.delivered_count > 0 ? user.delivered_count : null }</span> */}
                            </div>
                          </div>
                        ) : (
                          <div className="userLastMessageInfo">
                            <div className="userMessage">
                              <p className="lastMessage">
                                {user.message.length <= 10
                                  ? user.message
                                  : user.message.substring(0, 10) + " ..."}
                              </p>
                            </div>
                            <div className="userTimeAndUnseenMessageCont">
                              <span className="lastMessagedeliverDate">
                                {lastMsgDate(user.created_at) +
                                  " | " +
                                  handleTime(user.created_at)}
                              </span>
                              {/* <span className='unseenMessageCount'>{user.delivered_count > 0 ? user.delivered_count : null}</span> */}
                            </div>
                          </div>
                        )
                      ) : (
                        <p className="deletedMessage">
                          <AiOutlineStop />
                          &nbsp;Message deleted&nbsp;&nbsp;
                          <span className="messageTime">
                            {lastMsgDate(user.created_at) +
                              " | " +
                              handleTime(user.created_at)}
                              
                          </span>
                        </p>
                      )}
                    </div>
                  </div>
                </>
              );
            })
          ) : search.length > 0 ? (
            <p
              style={{
                width: "100%",
                height: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "30px",
                color: "gray",
                fontFamily: "Cantarell,sans-serif",
              }}
            >
              <RiUserSearchLine style={{ fontSize: "40px" }} />
              &nbsp;No results found
            </p>
          ) : active.length > 0 ? (
            active.map((user, index) => {
              return (
                <>
                  <div
                    className={`userQueryList ${
                      room == user.user_user_id ? "changeBackQuery" : null
                    }`}
                    key={user.user_user_id}
                    onClick={() => {
                      user.message_status = "seen";
                      chatWindow(
                        user.user_user_id,
                        user.full_name,
                        user.profile_image
                      );
                    }}
                  >
                    <div className="userImageAndNameCont">
                      <img
                        src={user.profile_image}
                        className="userProfileImageInChatInfo"
                      />
                    </div>
                    <div className="userLastMessageContainer">
                      <div className="nameAndUnseenMsgCont">
                        {user.message_status === "delivered" ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              width: "90%",
                            }}
                          >
                            <b>
                              <p className="userNameQuery">{user.full_name}</p>
                            </b>
                            <div
                              style={{
                                width: "10px",
                                height: "10px",
                                background: "white",
                                borderRadius: "100px",
                              }}
                            />
                          </div>
                        ) : (
                          <p className="userNameQuery">{user.full_name}</p>
                        )}
                        {/* { 
                    user.unseen_messages != 0 ?
                   <p className='unseenMessageCount'>{user.unseen_messages}</p>  : null
                  } */}
                      </div>
                      {user.message_status != "inactive" ? (
                        user.media_type == "image" ? (
                          <div className="userLastMessageInfo">
                            <div className="userMessage">
                              <p className="lastMessage">
                                <BsImageFill />
                                &nbsp;Image
                              </p>
                            </div>
                            <div className="userTimeAndUnseenMessageCont">
                              <span className="lastMessagedeliverDate">
                                {lastMsgDate(user.created_at) +
                                  " | " +
                                  handleTime(user.created_at)}
                              </span>
                              {/* <span className='unseenMessageCount'>{user.delivered_count > 0 ? user.delivered_count : null}</span> */}
                            </div>
                          </div>
                        ) : user.media_type == "video" ? (
                          <div className="userLastMessageInfo">
                            <div className="userMessage">
                              <p className="lastMessage">
                                <BsFillCameraVideoFill />
                                &nbsp;Video
                              </p>
                            </div>
                            <div className="userTimeAndUnseenMessageCont">
                              <span className="lastMessagedeliverDate">
                                {lastMsgDate(user.created_at) +
                                  " | " +
                                  handleTime(user.created_at)}
                              </span>
                              {/* <span className='unseenMessageCount'>{user.delivered_count > 0 ? user.delivered_count : null }</span> */}
                            </div>
                          </div>
                        ) : (
                          <div className="userLastMessageInfo">
                            <div className="userMessage">
                              <p className="lastMessage">
                                {user.message.length <= 10
                                  ? user.message
                                  : user.message.substring(0, 10) + " ..."}
                              </p>
                            </div>
                            <div className="userTimeAndUnseenMessageCont">
                              <span className="lastMessagedeliverDate">
                                {lastMsgDate(user.created_at) +
                                  " | " +
                                  handleTime(user.created_at)}
                              </span>
                              {/* <span className='unseenMessageCount'>{user.delivered_count > 0 ? user.delivered_count : null}</span> */}
                            </div>
                          </div>
                        )
                      ) : (
                        <div className="userLastMessageInfo">
                          <div className="userMessage">
                            <p className="lastMessage">
                              <AiOutlineStop />
                              &nbsp;Message deleted
                            </p>
                          </div>
                          <div className="userTimeAndUnseenMessageCont">
                            <span className="lastMessagedeliverDate">
                              {lastMsgDate(user.created_at) +
                                " | " +
                                handleTime(user.created_at)}
                            </span>
                            {/* <span className='unseenMessageCount'>{user.delivered_count > 0 ? user.delivered_count : null}</span> */}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              );
            })
          ) : (
            <div className="userQueryListContainer">
              {numOfSkeleton.map(() => {
                return (
                  <div className="userQueryList">
                    <div className="userImageAndNameCont">
                      <Skeleton
                        animation="wave"
                        className="userProfileImageInChatInfo"
                        variant="circular"
                        width={40}
                        height={40}
                      />
                    </div>
                    <div className="userLastMessageContainer">
                      <div className="nameAndUnseenMsgCont">
                        <p className="userNameQuery">
                          <Skeleton
                            animation="wave"
                            variant="text"
                            width={"100%"}
                          />
                        </p>
                      </div>
                      {
                        <div className="userLastMessageInfo">
                          <div className="userMessage">
                            &nbsp;
                            <Skeleton
                              animation="wave"
                              variant="text"
                              width={"90%"}
                            />
                          </div>
                          <div className="userTimeAndUnseenMessageCont">
                            <Skeleton
                              animation="wave"
                              variant="text"
                              width={"90%"}
                            />
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
      {
        <div className="canvaContainer">
          <Offcanvas className="h-100 p-0" show={canvaShow} placement="bottom">
            <div className="chatHeaderCanvasContainer">
              <div className="backArrowBtnContainer" onClick={handleCanva}>
                <BiArrowBack className="backArrowBtn" />
              </div>
              <div
                style={{ display: "flex", alignItems: "center" }}
                onClick={openUserProfile}
              >
                <div
                  className="userImagePlaceholderContainer"
                  style={{ backgroundImage: `url(${profileImage})` }}
                ></div>
                <p className="chatUserName">{chatName}</p>
              </div>
            </div>
            <div ref={scrollRef} className="chatBodyCanvasContainer w-100">
              {loadmessages.length == 0 ? (
                <div className="spinnerContainer ">
                  <Spinner animation="border" variant="primary" />
                </div>
              ) : (
                chat &&
                loadmessages &&
                loadmessages.map((lmsg, index) => {
                  return (
                    <div>
                      <div className="chatStartDateContainer">
                        {window.innerWidth <= 440 &&
                          handleDate(lmsg.created_at)}
                      </div>
                      {lmsg.sent_by == "admin" ? (
                        <div className="rightSideChatContainer" key={index}>
                          {lmsg.message_status != "inactive" ? (
                            <div
                              className="deleteMsgContainer"
                              onClick={() => deleteMsg(lmsg.chat_id)}
                            >
                              <AiFillDelete className="deleteIcon" />
                            </div>
                          ) : null}
                          <div className="messageInfoContainerRight">
                            <p className="SentByName">You</p>
                            {lmsg.message_status != "inactive" ? (
                              lmsg.media_type == "text" ? (
                                <>
                                  <div className="message">
                                    <p
                                      style={{ marginBottom: "0px" }}
                                      dangerouslySetInnerHTML={{
                                        __html: Linkify(lmsg.message),
                                      }}
                                    />
                                    <span className="messageTime">
                                      {handleTime(lmsg.created_at)}
                                      {lmsg.message_status == 'seen' ? <MdDoneAll style={{fontSize: '12px', marginLeft: '5px'}} /> : <BiCheck style={{fontSize: '12px', marginLeft: '5px'}} />}
                                    </span>{" "}
                                  </div>
                                </>
                              ) : lmsg.media_type == "image" ? (
                                <>
                                  <img
                                    src={lmsg.url}
                                    style={{
                                      width: "200px",
                                      height: "auto",
                                      maxHeight: "360px",
                                    }}
                                    onClick={() => handleShowImage(lmsg.url)}
                                  />{" "}
                                  <p className="messageMediaTime">
                                    {handleTime(lmsg.created_at)}
                                  </p>{" "}
                                </>
                              ) : (
                                <div
                                  className="chatVideo"
                                  onClick={() => handleShowVideo(lmsg.url)}
                                >
                                  {" "}
                                  <video
                                    className="rightChatVideo"
                                    height={"200px"}
                                    width={"200px"}
                                  >
                                    {" "}
                                    <source src={lmsg.url} />
                                  </video>
                                  <BsFillPlayCircleFill
                                    className="videoPlayBtn"
                                    style={{ fontSize: "40px", color: "#fff" }}
                                  />
                                  <p className="messageMediaTime">
                                    {handleTime(lmsg.created_at)}
                                  </p>
                                </div>
                              )
                            ) : (
                              <p className="deletedMessage">
                                <AiOutlineStop />
                                &nbsp;You deleted this message&nbsp;&nbsp;
                                <span className="messageTime">
                                  {handleTime(lmsg.created_at)}
                                </span>
                              </p>
                            )}
                          </div>
                        </div>
                      ) : (
                        <div className="leftSideChatContainer" key={index}>
                          <div className="messageInfoContainerLeft">
                            <p className="userSentByName">{lmsg.sent_by}</p>
                            {lmsg.media_type == "text" ? (
                              <>
                                <div className="message">
                                  <p
                                    style={{ marginBottom: "0px" }}
                                    dangerouslySetInnerHTML={{
                                      __html: Linkify(lmsg.message),
                                    }}
                                  />
                                  <span className="messageTime">
                                    {handleTime(lmsg.created_at)}
                                    {lmsg.message_status == 'seen' ? <MdDoneAll style={{fontSize: '12px', marginLeft: '5px'}} /> : <BiCheck style={{fontSize: '12px', marginLeft: '5px'}} />}
                                  </span>{" "}
                                </div>
                              </>
                            ) : lmsg.media_type == "image" ? (
                              <>
                                <img
                                  src={lmsg.url}
                                  style={{
                                    width: "200px",
                                    height: "auto",
                                    maxHeight: "360px",
                                  }}
                                  onClick={() => handleShowImage(lmsg.url)}
                                />{" "}
                                <p className="messageMediaTime">
                                  {handleTime(lmsg.created_at)}
                                </p>{" "}
                              </>
                            ) : (
                              <div
                                className="chatVideo"
                                onClick={() => handleShowVideo(lmsg.url)}
                              >
                                {" "}
                                <video
                                  className="rightChatVideo"
                                  height={"200px"}
                                  width={"200px"}
                                >
                                  {" "}
                                  <source src={lmsg.url} />
                                </video>
                                <BsFillPlayCircleFill
                                  className="videoPlayBtn"
                                  style={{ fontSize: "40px", color: "#fff" }}
                                />
                                <p className="messageMediaTime">
                                  {handleTime(lmsg.created_at)}
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })
              )}
              <div ref={containerRef}></div>
            </div>
            <div className="chatFooterCanvasContainer">
              <label className="chatAttachmentLabel">
                <div className="chatFileButton">
                  <IoIosImages
                    className="chatFileBtn"
                    style={{ color: "#fff" }}
                  />
                </div>
                <input
                  type="file"
                  name="file"
                  className="chatAttachment"
                  onChange={handleFile}
                />
              </label>
              <textarea
                rows={10}
                cols={10}
                className="messageInput"
                name="message"
                value={curr_message}
                ref={inputRef}
                onClick={() => {
                  setTimeout(() => {
                    scrollToDown();
                  }, 100);
                }}
                placeholder="Type a message"
                onChange={(event) => setCurrMessage(event.target.value)}
              />
              <button
                className="sendMessageBtn"
                onClick={() => sendMessage("", "text")}
              >
                <LuSendHorizonal
                  className="sendMessageArrow"
                  style={{ fontSize: "18px" }}
                />
              </button>
            </div>
            <CustomModal
              show={show}
              handleClose={handleClose}
              imageUrl={imageUrl}
              videoUrl={videoUrl}
              title={""}
              btnText={""}
              bodyContent={""}
              displayHeader={false}
              displayBody={true}
              displayFooter={false}
              backgroundClr={"transparent"}
              sendMessage={null}
            />
            <CustomModal
              show={mediaModalShow}
              handleClose={handleClose}
              imageUrl={imageUrl}
              videoUrl={videoUrl}
              title={"Preview"}
              btnText={"Send"}
              bodyContent={""}
              displayHeader={true}
              displayBody={true}
              displayFooter={true}
              backgroundClr={"#253287"}
              sendMessage={sendMessage}
            />
          </Offcanvas>
        </div>
      }
      <div className="chatRightSection">
        {loadmessages.length == 0 ? (
          <ImageContainer />
        ) : (
          <>
            <div onClick={openUserProfile} className="chatHeaderContainer">
              <div
                className="userImagePlaceholderContainer"
                style={{ backgroundImage: `url(${profileImage})` }}
              ></div>
              <p className="chatUserName">{chatName}</p>
            </div>
            <div className="chatBodyContainer">
              <SnackBar
                status={snackbarStatus}
                snackBarState={setSnakckbarStatus}
              />
              {chat &&
                loadmessages &&
                loadmessages.map((lmsg, index) => {
                  return (
                    <div>
                      <div className="chatStartDateContainer">
                        {handleDate(lmsg.created_at)}
                      </div>
                      {lmsg.sent_by == "admin" ? (
                        <div className="rightSideChatContainer" key={index}>
                          {lmsg.message_status != "inactive" ? (
                            <div
                              className="deleteMsgContainer"
                              onClick={() => deleteMsg(lmsg.chat_id)}
                            >
                              <AiFillDelete
                                className="deleteIcon"
                                style={{ color: "white" }}
                              />
                            </div>
                          ) : null}
                          <div className="messageInfoContainerRight">
                            <p className="SentByName">
                              You{" "}
                              {lmsg.media_type == "text" &&
                              lmsg.message_status != "inactive" ? (
                                <MdContentCopy
                                  onClick={() => copyText(lmsg.message)}
                                  style={{
                                    color: "#b2b2b2",
                                    cursor: "pointer",
                                  }}
                                />
                              ) : null}
                            </p>
                            {lmsg.message_status != "inactive" ? (
                              lmsg.media_type == "text" ? (
                                <>
                                  <p className="message">
                                    <p
                                      style={{ marginBottom: "0px" }}
                                      dangerouslySetInnerHTML={{
                                        __html: Linkify(lmsg.message),
                                      }}
                                    />
                                    <span className="messageTime">
                                      {handleTime(lmsg.created_at)}
                                    </span>{" "}
                                  </p>
                                </>
                              ) : lmsg.media_type == "image" ? (
                                <>
                                  <img
                                    src={lmsg.url}
                                    width={"200px"}
                                    height={"auto"}
                                    onClick={() => handleShowImage(lmsg.url)}
                                  />{" "}
                                  <p className="messageMediaTime">
                                    {handleTime(lmsg.created_at)}
                                  </p>{" "}
                                </>
                              ) : (
                                <div
                                  className="chatVideo"
                                  onClick={() => handleShowVideo(lmsg.url)}
                                >
                                  {" "}
                                  <video
                                    className="rightChatVideo"
                                    height={"200px"}
                                    width={"200px"}
                                  >
                                    {" "}
                                    <source src={lmsg.url} />
                                  </video>
                                  <BsFillPlayCircleFill
                                    className="videoPlayBtn"
                                    style={{ fontSize: "40px", color: "#fff" }}
                                  />
                                  <p className="messageMediaTime">
                                    {handleTime(lmsg.created_at)}
                                  </p>
                                </div>
                              )
                            ) : (
                              <p className="deletedMessage">
                                <AiOutlineStop />
                                &nbsp;You deleted this message&nbsp;&nbsp;
                                <span className="messageTime">
                                  {handleTime(lmsg.created_at)}
                                </span>
                              </p>
                            )}
                          </div>
                        </div>
                      ) : (
                        <div className="leftSideChatContainer" key={index}>
                          <div className="messageInfoContainerLeft">
                            <p className="userSentByName">{lmsg.sent_by}</p>
                            {lmsg.media_type == "text" ? (
                              <>
                                <p className="message">
                                  <p
                                    style={{ marginBottom: "0px" }}
                                    dangerouslySetInnerHTML={{
                                      __html: Linkify(lmsg.message),
                                    }}
                                  />
                                  <span className="messageTime">
                                    {handleTime(lmsg.created_at)}
                                  </span>{" "}
                                </p>
                              </>
                            ) : lmsg.media_type == "image" ? (
                              <>
                                <img
                                  src={lmsg.url}
                                  width={"200px"}
                                  height={"auto"}
                                  onClick={() => handleShowImage(lmsg.url)}
                                />{" "}
                                <p className="messageMediaTime">
                                  {handleTime(lmsg.created_at)}
                                </p>{" "}
                              </>
                            ) : (
                              <div
                                className="chatVideo"
                                onClick={() => handleShowVideo(lmsg.url)}
                              >
                                {" "}
                                <video
                                  className="rightChatVideo"
                                  height={"200px"}
                                  width={"200px"}
                                >
                                  {" "}
                                  <source src={lmsg.url} />
                                </video>
                                <BsFillPlayCircleFill
                                  className="videoPlayBtn"
                                  style={{ fontSize: "40px", color: "#fff" }}
                                />
                                <p className="messageMediaTime">
                                  {handleTime(lmsg.created_at)}
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              <div ref={containerRef}></div>
            </div>
            <div className="chatFooterContainer">
              <label className="chatAttachmentLabel">
                <div className="chatFileButton">
                  <IoIosImages
                    className="chatFileBtn"
                    style={{ color: "#fff" }}
                  />
                </div>
                <input
                  type="file"
                  name="file"
                  className="chatAttachment"
                  onChange={handleFile}
                />
              </label>
              <textarea
                rows={10}
                cols={10}
                className="messageInput"
                name="message"
                value={curr_message}
                placeholder="Type a message"
                onChange={(event) => {
                  if (event.key === "Enter") return;
                  setCurrMessage(event.target.value);
                }}
              />
              <button
                className="sendMessageBtn"
                onClick={() => sendMessage("", "text")}
              >
                <LuSendHorizonal
                  className="sendMessageArrow"
                  style={{ fontSize: "18px" }}
                />
              </button>
            </div>
          </>
        )}
      </div>
      <CustomModal
        show={show}
        handleClose={handleClose}
        imageUrl={imageUrl}
        videoUrl={videoUrl}
        title={""}
        btnText={""}
        bodyContent={""}
        displayHeader={false}
        displayBody={true}
        displayFooter={false}
        backgroundClr={"transparent"}
        sendMessage={null}
      />
      <CustomModal
        show={mediaModalShow}
        handleClose={handleClose}
        imageUrl={imageUrl}
        videoUrl={videoUrl}
        title={"Preview"}
        btnText={"Send"}
        bodyContent={""}
        displayHeader={true}
        displayBody={true}
        displayFooter={true}
        backgroundClr={"#253287"}
        sendMessage={sendMessage}
      />
      <Modal show={modal} onHide={() => setModal(false)} centered>
        <Modal.Header closeButton>{userProfile.user.full_name}</Modal.Header>
        <Modal.Body>
          <div className="" style={{ display: "flex", width: "100%" }}>
            <p>Full name:</p>
            <p style={{ marginLeft: "10px" }}>{userProfile.user.full_name}</p>
          </div>
          <div className="" style={{ display: "flex", width: "100%" }}>
            <p>Contact:</p>
            <a
              href={`tel:${userProfile.user.contact}`}
              style={{ marginLeft: "10px" }}
            >
              {userProfile.user.contact}
            </a>
          </div>
          <div className="" style={{ display: "flex", width: "100%" }}>
            <p>Class:</p>
            <p style={{ marginLeft: "10px" }}>{userProfile.user.view_class}</p>
          </div>
          <div className="" style={{ display: "flex", width: "100%" }}>
            <p>Signup time:</p>
            <p style={{ marginLeft: "10px" }}>
              {timestampToHumanDate(userProfile.user.created_at)}
            </p>
          </div>
          <div className="" style={{ display: "flex", width: "100%" }}>
            <p>Locked Coupon Code:</p>
            <p style={{ marginLeft: "10px" }}>{userProfile.user.coupon_code}</p>
          </div>
          <div className="" style={{ display: "flex", width: "100%" }}>
            <p>User Type:</p>
            <p style={{ marginLeft: "10px" }}>
              {userProfile.user.user_type}
              {userProfile.user.user_type === "paid" ? (
                <span style={{ marginLeft: "10px", fontSize: "12px" }}>
                  (
                  {userProfile.orders
                    .filter((ele) => ele.status == "paid")
                    .map((ele) => {
                      if (ele.subscription_type === "annual")
                        ele.subscription_type = "complete10";
                      if (ele.coupon_coupon_id) {
                        return (
                          ele.subscription_type +
                          ` + coupon code: ${ele.coupon_code}`
                        );
                      } else {
                        return ele.subscription_type + " + book";
                      }
                    })
                    .join(", ")}
                  )
                </span>
              ) : null}
            </p>
          </div>
          <div className="" style={{ display: "flex", width: "100%" }}>
            <p>Orders created:</p>
            <p style={{ marginLeft: "10px" }}>{userProfile.orders.length}</p>
          </div>
          {userProfile.orders.length > 0 ? (
            <div className="" style={{ display: "flex", width: "100%" }}>
              <p>Last order created at:</p>
              <p style={{ marginLeft: "10px" }}>
                {timestampToHumanDate(
                  userProfile.orders[userProfile.orders.length - 1].created_at
                )}{" "}
                <span>
                  (
                  {
                    userProfile.orders[userProfile.orders.length - 1]
                      .subscription_type
                  }
                  , {userProfile.orders[userProfile.orders.length - 1].amount})
                </span>
              </p>
            </div>
          ) : null}
          {userProfile.user.user_type == "paid" ? (
             <div className="" style={{ width: "100%" }}>
             <p>All Paid Orders:</p>
             <table>
               <tr style={{border: '0.5px solid gray'}}>
                 <th style={{width: '13%', textAlign: 'center'}}>amount</th>
                 <th style={{width: '33%',textAlign: 'center'}}>Date</th>
                 <th style={{width: '43%',textAlign: 'center'}}>Order type</th>
                 <th style={{width: '13', textAlign: 'center'}}>Invoice</th>
               </tr>
               {userProfile.orders
                 .filter((o) => o.status === "paid")
                 .map((ele) => {
                   let subtype
                   if (ele.subscription_type === "annual")
                   ele.subscription_type = "complete10";
                 if (ele.coupon_coupon_id) {
                   subtype = ele.subscription_type +
                     ` + coupon code: ${ele.coupon_code}`
                   
                 } else {
                  if(ele.subscription_type === 'single_chapter') {
                    subtype = ele.subscription_type 
                  } else {

                    subtype = ele.subscription_type + " + book";
                  }
                 }
                   return (
                     <tr style={{border: '0.5px solid gray'}}>
                       <td style={{textAlign: 'center'}}>{ele.amount}</td>
                       <td style={{textAlign: 'center', padding: '10px 0px'}}>{timestampToHumanDate(ele.created_at)}</td>
                       <td style={{textAlign: 'center', padding: '10px 0px'}}>{subtype }</td>
                       <td><a href={`https://point-editor.web.app/invoice?order_id=${ele.order_id}`} target="_blank">open</a></td>
                     </tr>
                   );
                 })}
             </table>
           </div>
          ) : null}
          {userProfile.orders.length > 0 ? (
            <div className="" style={{ display: "flex", width: "100%", marginTop: '20px' }}>
              <p>Name used on Order:</p>
              <p style={{ marginLeft: "10px" }}>
                {userProfile.orders[userProfile.orders.length - 1].full_name}
              </p>
            </div>
          ) : null}
          {userProfile.orders.find((ele) => ele.status == "paid") ? (
            <div className="" style={{ display: "flex", width: "100%" }}>
              <p>Last order tracking id:</p>
              <p style={{ marginLeft: "10px" }}>
                {userProfile.orders[userProfile.orders.length - 1]
                  .tracking_id || "NA"}
              </p>
            </div>
          ) : null}
          {userProfile.orders.find((ele) => ele.status == "paid") ? (
            <div className="" style={{ display: "flex", width: "100%" }}>
              <p>Order Status:</p>
              <p style={{ marginLeft: "10px" }}>
                {userProfile.orders[userProfile.orders.length - 1]
                  .order_status || "NA"}
              </p>
            </div>
          ) : null}
          <div className="" style={{ display: "flex", width: "100%" }}>
            <p>Last Chat Status:</p>
            <p style={{ marginLeft: "10px" }}>
              {userProfile.lastchat?.message_status || "NA"}
            </p>
          </div>
         
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Chat;
